import parseIsoZulu from 'utils/parsers/parseIsoZulu.util';

// hours * minutes * seconds * milliseconds
// but subtract one millisecond since the end uses 999
const FULL_DAY_INTERVAL = 24 * 60 * 60 * 1000 - 1;

const detectDst = (iso) => {
  const { is, days, months, years } = parseIsoZulu(iso);

  if (!is.valid) return NaN;

  // TODO: use hours and minutes to detect times of day before the DST change took place

  const bgn = new Date(`${years}-${months}-${days}T00:00:00.000`);
  const end = new Date(`${years}-${months}-${days}T23:59:59.999`);

  // subtracting 0 converts the date object into a number of milliseconds
  return FULL_DAY_INTERVAL - (end - 0) + (bgn - 0);
};

export default detectDst;
